import React from 'react';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    size?: number;
};

const HelpCircleIcon = ({
    color = 'currentColor',
    size = 24,
    strokeWidth = 2,
    strokeLinecap = 'round',
    strokeLinejoin = 'round',
    ...props
}: Props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={size} height={size} {...props}>
        <path
            stroke={color}
            strokeLinecap={strokeLinecap}
            strokeLinejoin={strokeLinejoin}
            strokeWidth={strokeWidth}
            d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3m.08 4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
        />
    </svg>
);
export { HelpCircleIcon };
